export const getEachWayTitle = (eachWayTranslation, placeTerms, oddsTerms) => {
    //  $string('General').EachWay vs $string('General').EachWayTag
    if (placeTerms <= 0 || oddsTerms <= 0) {
        return "";
    }
    var pt = placeTerms;
    var eachWay = `${eachWayTranslation} 1/${oddsTerms}`;
    let options = [];
    for (let i = 1; i <= pt; i++) {
        options.push(i);
    }
    return `- ${eachWay} ${options.join("-")}`;
};
//# sourceMappingURL=getEachWayTitle.js.map